import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleMenu() {
    $('#recommendations-menu').toggle();
  }
}
